import styled from '@emotion/styled';

const Wrapper = styled.div`
  & .react-switch-bg {
    border: ${({ theme }) => `1px solid ${theme.colors.secondary}`};
  }
`;

export default Wrapper;
